import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  fieldsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    columnGap: 16,
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr 1fr ',
      columnGap: 8
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr'
    }
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  checkboxContainer: {
    [theme.breakpoints.down('xs')]: {
      marginTop: 30
    }
  },
  childrenDetailsSection: {
    marginBottom: 40
  },
  childN: {
    marginBottom: 10
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  paper: {
    margin: 'auto',
    maxWidth: 400,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  profileImage: {
    width: '100%',
    height: '100%'
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))

export default useStyles
